import { supabase } from '../lib/supabase';

/**
 * Service pour les opérations d'administration d'authentification
 * Utilise les Edge Functions pour les opérations nécessitant la clé service_role
 */

interface UpdateUserPasswordParams {
  userId: string;
  password: string;
  email?: string;
  name?: string;
}

interface UpdateUserPasswordResponse {
  success: boolean;
  message?: string;
  error?: string;
}

/**
 * Met à jour le mot de passe d'un utilisateur (nécessite rôle admin)
 */
export const updateUserPassword = async (
  params: UpdateUserPasswordParams
): Promise<UpdateUserPasswordResponse> => {
  try {
    // Récupérer le token de session actuel
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session) {
      throw new Error('No active session');
    }

    // Appeler l'Edge Function
    const { data, error } = await supabase.functions.invoke('admin-update-user-password', {
      body: {
        userId: params.userId,
        password: params.password,
        email: params.email,
        name: params.name
      },
      headers: {
        Authorization: `Bearer ${session.access_token}`
      }
    });

    if (error) {
      console.error('Edge Function error:', error);
      throw error;
    }

    if (!data.success) {
      throw new Error(data.error || 'Failed to update password');
    }

    return {
      success: true,
      message: data.message
    };

  } catch (error: any) {
    console.error('Error updating user password:', error);
    return {
      success: false,
      error: error.message || 'An error occurred while updating the password'
    };
  }
};
